import { PropsWithChildren, useEffect } from 'react';
import { ErrorBoundary } from '@sentry/nextjs';
import { logger } from '@zep/core-logger';
import { setApiNetworkLoggerWeb } from '@zep/next';
import { Error500PageView } from '@zep/web-components';
export const GlobalErrorBoundary = ({
  children,
  onResetError
}: PropsWithChildren & {
  onResetError?(): void;
}) => {
  useUnhandledRejectionErrors(({
    reason: error
  }) => {
    console.log('Global Error Occurred => ', error);
  });
  return <ErrorBoundary beforeCapture={scope => {
    scope.setTag('globalErrorBoundaryRendered', true);
  }} fallback={({
    error,
    resetError
  }) => <Error500PageView error={error} onResetError={() => {
    resetError();
    onResetError?.();
  }} />} onError={e => {
    const isNetworkError = setApiNetworkLoggerWeb(e);
    if (isNetworkError) {
      logger.track('on_network_error');
      return;
    }
    console.error('Error Boundary:', e);
    // 대시보드 호환: error_captured(auto)와 별도로 user-facing boundary 도달을 표시
    logger.track('enter_error_boundary', {
      errorName: e instanceof Error ? e.name : 'Unknown'
    });
    logger.captureError(e, {
      tags: {
        source: 'GlobalErrorBoundary'
      }
    });
  }} data-sentry-element="ErrorBoundary" data-sentry-component="GlobalErrorBoundary" data-sentry-source-file="GlobalErrorBoundary.tsx">
      {children}
    </ErrorBoundary>;
};
export const useUnhandledRejectionErrors = (handler: Handler) => {
  useEffect(() => {
    window.addEventListener('unhandledrejection', handler);
    return () => {
      window.removeEventListener('unhandledrejection', handler);
    };
  }, [handler]);
};
type Handler = (event: PromiseRejectionEvent) => void;